var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.07 0C14.687 0 16 1.314 16 2.93c0 1.51-1.148 2.756-2.617 2.912h0v5.112c0 .322-.134.633-.369.853l-.004.004c-.218.202-.5.314-.797.314h0H1.17c-.298 0-.582-.112-.8-.316 0 0 0 0 0 0-.236-.221-.371-.532-.371-.855h0v-7.57c0-.317.125-.615.352-.837l.003-.002h0c.22-.214.51-.331.816-.331h9.059C10.55.944 11.702 0 13.07 0zM7.91 7.835l-.675.638c-.058.055-.135.086-.215.086h0-.657c-.08 0-.157-.031-.215-.086h0l-.675-.638-4.31 3.664H12.22L7.91 7.836zM.638 3.265c-.009.038-.013.079-.013.12h0v7.57c0 .055.008.11.024.16h0l4.367-3.712zm10.319 1.69l-2.59 2.448 4.367 3.713c.016-.052.024-.106.024-.162h0V5.842c-.705-.075-1.336-.401-1.801-.887h0zm-.814-2.116H1.17c-.022 0-.045.001-.068.004h0l5.385 5.09h.409l3.677-3.475c-.274-.445-.431-.969-.431-1.529l.001-.09h0zM13.071.625c-1.27 0-2.304 1.034-2.304 2.304 0 1.271 1.033 2.305 2.304 2.305 1.27 0 2.304-1.034 2.304-2.304 0-1.271-1.034-2.305-2.304-2.305zm.105 1.304c.172 0 .312.14.312.312h0v1.562c0 .173-.14.313-.312.313-.173 0-.313-.14-.313-.313h0v-1.25h-.021c-.173 0-.313-.14-.313-.312s.14-.312.313-.312h0z",
    transform: "translate(-1132 -175) translate(1119 72) translate(0 90) translate(14 14)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotification);
export default __webpack_public_path__ + "static/media/email-notification.147d2df0.svg";
export { ForwardRef as ReactComponent };